import { redirectToStandaloneShell } from "@ark/platform/standalone";

redirectToStandaloneShell(
  "drive",
  window.location,
  import.meta.env.VITE_SHELL_BASE_URL,
);
